import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from "vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AddSiteCosts',
  props: {
    siteCosts: {
      type: Number,
      required: true,
    },
  },
  emits: ["addSiteCosts"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emit = __emit;

  const siteCostsSelected = ref(props.siteCosts);

  watch(siteCostsSelected, (newValue) => {
    siteCostsSelected.value = newValue;
    emit("addSiteCosts", newValue);
  });

  onMounted(() => {
    if (props.siteCosts) {
      emit("addSiteCosts", props.siteCosts);
    }
  });

const __returned__ = { props, emit, siteCostsSelected, onMounted, ref, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})